// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';

const SecondhandShoppers: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        There Are More Secondhand Shoppers Than Ever Before
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-20">
        <div className="col-span-2">
          <h2
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 1}
            className="max-w-lg"
          >
            70% of women have or are open to shopping secondhand.
          </h2>
          <SlideReveal>
            <Image
              alt="Consumer trends chart"
              fileName="3a-womenSecondhand.png"
            />
          </SlideReveal>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 2}
            className="tup-description"
          >
            Percentage of women over 18 who have bought or are open to buying
            secondhand products in the future<sup>2</sup>
          </p>
        </div>
        <div
          data-sal-delay={SAL_DELAY * 3}
          data-sal="fade"
          className="text-center mt-8 md:mt-0"
        >
          <h3 className="tup-number">62M</h3>
          <p className="p-8 pt-0 pb-2">
            women bought secondhand products in 2019, up from <b>56M</b> in
            2018.<sup>2</sup>
          </p>
          <Image
            alt="Women Shopping for clothes"
            fileName="3a-womenShopping.jpg"
          />
          <p className="p-8 pt-2 pb-0">
            <b>82%</b> of people have or are open to shopping secondhand when
            money gets tighter.<sup>3</sup>
          </p>
        </div>
      </div>
    </div>
  );
};

export { SecondhandShoppers };
